import { styled } from "@mui/material/styles";

// Forward native width/height attributes while supporting responsive sx styles.
const Image = styled("img")({ display: "block" });

export default Image;
